<div class="tabs-container" [attr.type]="type" *ngIf="filteredTabs.length > 1">
	<div class="tab" *ngFor="let tab of filteredTabs" (click)="tabSelected(tab)" [class.active]="currentTab === tab.value || currentTab === tab.label" [attr.cy-elm]="tab.label + ' tab' | kebab">
		<span>{{tab.label}}</span>
		<div class="count" *ngIf="tab.count">{{tab.count}}</div>
	</div>
</div>
